// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Product_Wrapper__1XB9V"};